import withTextareaHookForm from '../hoc/withTextareaHookForm';
import TextareaBox from './TextareaBox';

const TextareaBoxWithHookForm = withTextareaHookForm(TextareaBox);

export default TextareaBoxWithHookForm;
